<template>
  <div>
    <div class="text-center mb-5">
      <b-img
        class="p-5"
        width="800"
        :src="require('@/assets/icons/503.svg')"
      ></b-img>
      <div class="center-screen">
        <div class="page-title mb-4">It’s not your fault</div>
        <div class="font-weight-bold mb-4">
          We are currently under maintenance.
          <br />Try again in a while!
        </div>
        <b-button class="back-btn" variant="primary" @click="$router.go()"
          >Refresh</b-button
        >
      </div>
      <b-img
        fluid
        width="1000"
        :src="require('@/assets/icons/no-results.svg')"
      ></b-img>
    </div>

    <footer-section />
  </div>
</template>

<script>
import FooterSection from '@/components/FooterSection'

export default {
  components: {
    FooterSection
  }
}
</script>

<style lang="scss" scoped>
.center-screen {
  min-height: auto;
  margin-top: -280px;
  margin-bottom: -80px;
}
.back-btn {
  width: 200px;
  z-index: 2;
}
</style>
